import { createAction } from '@reduxjs/toolkit';

import { NAME } from './constants';

export const cancelPlan = createAction<{ feedback: string }>(`${NAME}/cancelPlan`);

export const updateLanguagePreference = createAction<{ languageCode: string }>(`${NAME}/updateLanguagePreference`);

export const updateStudyInNativeLanguage = createAction<boolean>(`${NAME}/updateStudyInNativeLanguage`);
